import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './V3Account.css'

const API_BASE = 'https://backend.alephmedia.ro/api'

const V3Account = () => {
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [payments, setPayments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [editMode, setEditMode] = useState(false)
  const [passwordMode, setPasswordMode] = useState(false)
  
  const [editForm, setEditForm] = useState({
    first_name: '',
    last_name: '',
    phone: ''
  })

  const [passwordForm, setPasswordForm] = useState({
    old_password: '',
    password: '',
    password_confirmation: ''
  })

  useEffect(() => {
    const token = localStorage.getItem('authToken')
    if (!token) {
      navigate('/v3.0/login')
      return
    }

    fetchAccount()
    fetchPayments()
  }, [navigate])

  const fetchAccount = async () => {
    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('authToken')
          navigate('/v3.0/login')
          return
        }
        throw new Error('Nu am putut încărca datele contului')
      }

      const data = await response.json()
      if (data.success && data.data) {
        setUser(data.data)
        setEditForm({
          first_name: data.data.first_name || '',
          last_name: data.data.last_name || '',
          phone: data.data.phone || ''
        })
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const fetchPayments = async () => {
    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account/payments`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        if (data.success && data.data) {
          setPayments(data.data)
        }
      }
    } catch (err) {
      console.error('Failed to fetch payments', err)
    }
  }

  const handleUpdateProfile = async (e) => {
    e.preventDefault()
    setError(null)
    setSuccess(null)

    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account/update`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(editForm)
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Actualizare eșuată')
      }

      setSuccess('Datele au fost actualizate cu succes!')
      setEditMode(false)
      fetchAccount()
      
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      localStorage.setItem('userData', JSON.stringify({
        ...userData,
        first_name: editForm.first_name,
        last_name: editForm.last_name,
        phone: editForm.phone
      }))

      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setError(err.message)
    }
  }

  const handleChangePassword = async (e) => {
    e.preventDefault()
    setError(null)
    setSuccess(null)

    if (passwordForm.password !== passwordForm.password_confirmation) {
      setError('Parolele nu se potrivesc')
      return
    }

    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account/change-password`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(passwordForm)
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Schimbare parolă eșuată')
      }

      setSuccess('Parola a fost schimbată cu succes!')
      setPasswordMode(false)
      setPasswordForm({ old_password: '', password: '', password_confirmation: '' })
      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setError(err.message)
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('userData')
    localStorage.removeItem('subscriptionId')
    localStorage.removeItem('subscriptionLevel')
    localStorage.removeItem('__paypal_storage__')
    navigate('/v3.0/login')
  }

  if (loading) {
    return (
      <div className="v3-account-root">
        <div className="v3-account-loading">
          <div className="v3-account-spinner"></div>
          <p>Se încarcă...</p>
        </div>
      </div>
    )
  }

  if (error && !user) {
    return (
      <div className="v3-account-root">
        <div className="v3-account-error-page">
          <p>{error}</p>
          <button onClick={() => navigate('/v3.0')}>← Înapoi</button>
        </div>
      </div>
    )
  }

  return (
    <div className="v3-account-root">
      <div className="v3-account-container">
        <div className="v3-account-header">
          <button className="v3-account-back-btn" onClick={() => navigate('/v3.0')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
          </button>
          <h1>Profilul meu</h1>
          <div className="v3-account-avatar">
            {user?.first_name?.[0]?.toUpperCase() || user?.name?.[0]?.toUpperCase() || 'U'}
          </div>
        </div>

        {error && <div className="v3-account-error">{error}</div>}
        {success && <div className="v3-account-success">{success}</div>}

        {user && (
          <div className="v3-account-content">
            <div className="v3-account-card">
              <div className="v3-account-card-header">
                <h2>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  Informații personale
                </h2>
                {!editMode && (
                  <button className="v3-account-edit-btn" onClick={() => setEditMode(true)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                    Editează
                  </button>
                )}
              </div>

              {editMode ? (
                <form onSubmit={handleUpdateProfile} className="v3-account-form">
                  <div className="v3-account-field">
                    <label>Prenume</label>
                    <input
                      type="text"
                      value={editForm.first_name}
                      onChange={(e) => setEditForm({ ...editForm, first_name: e.target.value })}
                      placeholder="Prenume"
                    />
                  </div>
                  <div className="v3-account-field">
                    <label>Nume</label>
                    <input
                      type="text"
                      value={editForm.last_name}
                      onChange={(e) => setEditForm({ ...editForm, last_name: e.target.value })}
                      placeholder="Nume"
                    />
                  </div>
                  <div className="v3-account-field">
                    <label>Telefon</label>
                    <input
                      type="tel"
                      value={editForm.phone}
                      onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
                      placeholder="07xxxxxxxx"
                    />
                  </div>
                  <div className="v3-account-form-actions">
                    <button type="submit" className="v3-account-save-btn">Salvează</button>
                    <button type="button" className="v3-account-cancel-btn" onClick={() => setEditMode(false)}>
                      Anulează
                    </button>
                  </div>
                </form>
              ) : (
                <div className="v3-account-info">
                  <div className="v3-account-info-item">
                    <span className="v3-account-label">Nume complet:</span>
                    <span className="v3-account-value">
                      {user.first_name || ''} {user.last_name || user.name || 'Nu ai completat'}
                    </span>
                  </div>
                  <div className="v3-account-info-item">
                    <span className="v3-account-label">Email:</span>
                    <span className="v3-account-value">{user.email}</span>
                  </div>
                  <div className="v3-account-info-item">
                    <span className="v3-account-label">Telefon:</span>
                    <span className="v3-account-value">{user.phone || 'Nu ai adăugat'}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="v3-account-card">
              <div className="v3-account-card-header">
                <h2>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  Securitate
                </h2>
                {!passwordMode && (
                  <button className="v3-account-edit-btn" onClick={() => setPasswordMode(true)}>
                    Schimbă parola
                  </button>
                )}
              </div>

              {passwordMode && (
                <form onSubmit={handleChangePassword} className="v3-account-form">
                  <div className="v3-account-field">
                    <label>Parola veche</label>
                    <input
                      type="password"
                      value={passwordForm.old_password}
                      onChange={(e) => setPasswordForm({ ...passwordForm, old_password: e.target.value })}
                      placeholder="••••••••"
                      required
                    />
                  </div>
                  <div className="v3-account-field">
                    <label>Parola nouă</label>
                    <input
                      type="password"
                      value={passwordForm.password}
                      onChange={(e) => setPasswordForm({ ...passwordForm, password: e.target.value })}
                      placeholder="••••••••"
                      required
                      minLength={8}
                    />
                  </div>
                  <div className="v3-account-field">
                    <label>Confirmă parola</label>
                    <input
                      type="password"
                      value={passwordForm.password_confirmation}
                      onChange={(e) => setPasswordForm({ ...passwordForm, password_confirmation: e.target.value })}
                      placeholder="••••••••"
                      required
                      minLength={8}
                    />
                  </div>
                  <div className="v3-account-form-actions">
                    <button type="submit" className="v3-account-save-btn">Schimbă parola</button>
                    <button type="button" className="v3-account-cancel-btn" onClick={() => {
                      setPasswordMode(false)
                      setPasswordForm({ old_password: '', password: '', password_confirmation: '' })
                    }}>
                      Anulează
                    </button>
                  </div>
                </form>
              )}
            </div>

            {user.subscription_type && (
              <div className="v3-account-card v3-account-subscription">
                <div className="v3-account-card-header">
                  <h2>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                    Abonament
                  </h2>
                </div>
                <div className="v3-account-info">
                  <div className="v3-account-info-item">
                    <span className="v3-account-label">Plan:</span>
                    <span className={`v3-account-badge v3-account-badge--${user.subscription_type}`}>
                      {user.subscription_type === 'premium' ? 'Premium' : user.subscription_type === 'plus' ? 'Plus' : user.subscription_type}
                    </span>
                  </div>
                  <div className="v3-account-info-item">
                    <span className="v3-account-label">Status:</span>
                    <span className="v3-account-value">
                      {user.subscription_status === 'active' ? '✓ Activ' : user.subscription_status || 'Inactiv'}
                    </span>
                  </div>
                  {user.subscription_expires_at && (
                    <div className="v3-account-info-item">
                      <span className="v3-account-label">Expiră la:</span>
                      <span className="v3-account-value">
                        {new Date(user.subscription_expires_at).toLocaleDateString('ro-RO')}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {payments.length > 0 && (
              <div className="v3-account-card">
                <div className="v3-account-card-header">
                  <h2>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                      <line x1="1" y1="10" x2="23" y2="10"/>
                    </svg>
                    Istoric plăți
                  </h2>
                </div>
                <div className="v3-account-payments">
                  {payments.map((payment, index) => (
                    <div key={payment.id || index} className="v3-account-payment-item">
                      <div className="v3-account-payment-info">
                        <div className="v3-account-payment-amount">
                          {payment.amount} {payment.currency || 'RON'}
                        </div>
                        <div className="v3-account-payment-date">
                          {new Date(payment.created_at).toLocaleDateString('ro-RO', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </div>
                      </div>
                      <div className={`v3-account-payment-status v3-account-payment-status--${payment.status}`}>
                        {payment.status === 'completed' ? '✓ Finalizată' : payment.status}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="v3-account-actions">
              <button className="v3-account-logout" onClick={handleLogout}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Deconectare
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default V3Account

